import classNames from 'classnames';
import React, { Fragment, useEffect, useState } from 'react';
import IconChevronLeft from 'react/icons/icon_chevron_left';
import IconChevronRight from 'react/icons/icon_chevron_right';

interface PaginationProps {
  data: any;
  variant?: 'v2';
  setPage: (page: number) => void;
}

const Pagination = ({ data, variant, setPage }: PaginationProps) => {
  const [pageLoading, setPageLoading] = useState(null);

  const onPageClick = (page) => {
    setPage(page);
    setPageLoading(page);
  };

  useEffect(() => {
    setPageLoading(null);

    if (data && !data.length && data.meta && data.meta.page > 1) {
      setPage(data.meta.page - 1);
    }
  }, [data]);

  let pages = 0;

  if (data.meta) {
    pages = Math.ceil(data.meta.total / data.meta.count);
  }

  return (
    !!data.meta &&
    pages > 1 && (
      <ul className={variant === 'v2' ? 'pagination--v2' : 'pagination'}>
        <li className={classNames({ disabled: data.meta.page === 1 })}>
          <a
            onClick={() => {
              if (data.meta.page === 1) return;
              onPageClick(data.meta.page - 1);
            }}
          >
            {variant === 'v2' ? <IconChevronLeft width={24} height={24} /> : '«'}
          </a>
        </li>

        {Array.from({ length: pages }, (_, index) => index + 1).map((page) => {
          const disabled = data.meta.page === page || pageLoading === page;
          const hasFirstPageGap = data.meta.page > 4;
          const hasLastPageGap = pages - data.meta.page > 3;

          if (
            (hasFirstPageGap || hasLastPageGap) &&
            Math.abs(page - data.meta.page) > 2 &&
            page !== 1 &&
            page !== pages
          )
            return null;

          return (
            <Fragment key={page}>
              {page === pages && hasLastPageGap && (
                <li className="disabled">
                  <a>…</a>
                </li>
              )}
              <li
                className={classNames({
                  disabled: !variant && disabled,
                  active: variant && disabled,
                })}
              >
                <a
                  onClick={() => {
                    if (disabled) return;
                    onPageClick(page);
                  }}
                >
                  {page}
                </a>
              </li>
              {page === 1 && hasFirstPageGap && (
                <li className="disabled">
                  <a>…</a>
                </li>
              )}
            </Fragment>
          );
        })}

        <li className={classNames({ disabled: data.meta.page === pages })}>
          <a
            onClick={() => {
              if (data.meta.page === pages) return;
              onPageClick(data.meta.page + 1);
            }}
          >
            {variant === 'v2' ? <IconChevronRight width={24} height={24} /> : '»'}
          </a>
        </li>
      </ul>
    )
  );
};

export default Pagination;
